export const getSaintEmilionData = () => ({
  name: "Saint-Émilion",
  region: "Bordeaux",
  country: "France",
  description: "Saint-Émilion est une appellation prestigieuse de Bordeaux, célèbre pour ses vins rouges élégants et accessibles, dominés par le Merlot. Cette région produit des vins de grande qualité avec une identité terroir unique.",
  type: "subregion",
  area: "5,400 ha",
  production: "250,000 hectolitres",
  mapAreas: [
    { region: "Saint-Émilion", x: -0.2, y: 44.9, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat océanique tempéré, étés chauds, hivers doux",
    soil: "Argiles et limons de la rive droite, excellente structure",
    viticulture: "Rendements modérés, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges élégants et fruités, tannins doux et soyeux",
    white: "Vins blancs secs et aromatiques"
  },
  history: "La viticulture à Saint-Émilion remonte à l'époque romaine. Au Moyen Âge, les moines ont développé la viticulture. Le cépage Merlot est devenu le cépage emblématique de la région. Aujourd'hui, Saint-Émilion est reconnue pour ses vins de qualité et son identité terroir unique.",
  foodPairing: "Viandes blanches, volailles, fromages doux, cuisine française",
  grapeVarieties: [
    {
      name: "Merlot",
      percentage: "70%",
      description: "Cépage principal de Saint-Émilion, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Cabernet Franc",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, tanins fins",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de cassis",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ],
  subregions: {
    "saint-emilion-grand-cru": {
      name: "Saint-Émilion Grand Cru",
      description: "Zone de production des vins les plus prestigieux",
      characteristics: {
        climate: "Climat optimal",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Merlot", "Cabernet Franc", "Cabernet Sauvignon"]
      },
      wineStyles: {
        red: "Vins rouges de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "saint-emilion-satellites": {
      name: "Saint-Émilion Satellites",
      description: "Zones périphériques, produisant des vins plus accessibles",
      characteristics: {
        climate: "Climat légèrement plus frais",
        soil: "Sols variés",
        viticulture: "Viticulture moderne"
      },
      grapeVarieties: {
        red: ["Merlot", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges fruités et accessibles"
      },
      foodPairing: "Viandes blanches, charcuterie, fromages"
    }
  }
}); 